export const EMPTY_AGENT_TEMPLATE_FORM = {
  slug: "",
  name: "",
  purpose: "",
  category: "atendimento",
  language: "pt-BR",
  instructions: "",
  knowledgeRequirement: "optional",
  variables: "[]",
  examples: "[]",
  limits: JSON.stringify({ do: [], doNot: [] }, null, 2),
  recommendations: JSON.stringify(
    { modelId: "gpt-4.1-mini", temperature: 0.4, maxTokens: 700 },
    null,
    2
  ),
};

const stringify = (value, fallback) =>
  JSON.stringify(value === undefined || value === null ? fallback : value, null, 2);

export const agentTemplateToForm = (template) => {
  const version = template?.draftVersion || template?.publishedVersion || {};
  return {
    slug: template?.slug || "",
    name: version.name || "",
    purpose: version.purpose || "",
    category: version.category || "atendimento",
    language: version.language || "pt-BR",
    instructions: version.instructions || "",
    knowledgeRequirement: version.knowledgeRequirement || "optional",
    variables: stringify((version.variables || []).map(variable => ({ ...variable,
      source: variable.source || (variable.key === "empresa" ? "company.name" : "agent") })), []),
    examples: stringify(version.examples, []),
    limits: stringify(version.limits, { do: [], doNot: [] }),
    recommendations: stringify(version.recommendations, {}),
  };
};

export const parseAgentTemplateJson = (value, field, expectedType) => {
  let parsed;
  try {
    parsed = JSON.parse(value);
  } catch (_error) {
    throw new Error(`${field}: JSON inválido.`);
  }
  if (expectedType === "array" && !Array.isArray(parsed)) {
    throw new Error(`${field}: informe uma lista JSON.`);
  }
  if (
    expectedType === "object" &&
    (!parsed || Array.isArray(parsed) || typeof parsed !== "object")
  ) {
    throw new Error(`${field}: informe um objeto JSON.`);
  }
  return parsed;
};

export const agentTemplateFormToRequest = (form) => ({
  slug: form.slug.trim().toLowerCase(),
  content: {
    name: form.name.trim(),
    purpose: form.purpose.trim(),
    category: form.category.trim().toLowerCase(),
    language: form.language.trim(),
    instructions: form.instructions.trim(),
    knowledgeRequirement: form.knowledgeRequirement,
    variables: parseAgentTemplateJson(form.variables, "Variáveis", "array"),
    examples: parseAgentTemplateJson(form.examples, "Exemplos", "array"),
    limits: parseAgentTemplateJson(form.limits, "Limites", "object"),
    recommendations: parseAgentTemplateJson(
      form.recommendations,
      "Recomendações",
      "object"
    ),
  },
});
